import { RouterModule, Routes } from '@angular/router';
import { BuscadorSolicitudcamWrapperComponent } from './solicitudes/buscador-solicitudcam-wrapper/buscador-solicitudcam-wrapper.component';
import { ActionGuard, LoginGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { NgModule } from '@angular/core';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { BuscadorPvCamWrapperComponent } from './programasverificacion/buscador-pvcam-wrapper/buscador-pvcam-wrapper.component';
import { BuscadorUnidadInspeccionWrapperComponent } from './unidades-inspeccion/buscador-unidad-inspeccion-wrapper/buscador-unidad-inspeccion-wrapper.component';

const buscadoresCam: Routes = [
    // SOLICITUDES DE CAMPAÑA
    {
        path: 'campanias/solicitudes',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'CAMPAÑAS',
        },
        children: [
            {
                path: '',
                component: BuscadorSolicitudcamWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_SOL_CAM,
                },
            },
        ],
    },
    // PROGRAMAS DE VERIFICACIÓN
    {
        path: 'campanias/programasverificacion',
        data: {
            breadcrumb: 'Programas Verificación',
            menu0: 'CAMPAÑAS',
        },
        children: [
            {
                path: '',
                component: BuscadorPvCamWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.PROGRAMAS_VERIFICACION,
                },
            },
        ],
    },
    // UNIDADES DE INSPECCIÓN
    {
        path: 'campanias/unidadesinspeccion',
        data: {
            breadcrumb: 'Unidades de Inspección',
            menu0: 'CAMPAÑAS',
        },
        children: [
            {
                path: '',
                component: BuscadorUnidadInspeccionWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_UDS_INSPECCION,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(buscadoresCam)],
    exports: [RouterModule],
})
export class SolicitudesCamRoutingModule {}
